import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action';
import { deleteQaPair, updatePublishApi } from '../../API/api';


const ThreeDotMenu = ({question,answer,emailId,setLoading,published,onClickEmail,tickedId}) => {
  const dispatch = useDispatch();

  const {  advanceFilterModalToggle,getIngestedEmailAnswer,getIngestedEmailQuestion,getEmailId } = bindActionCreators(
    Actions,
    dispatch
  );
          // getIngestedEmailAnswer
        // getIngestedEmailQuesiton

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
 
  // change the publish status
  const changePublishStatus =  () => {
    setLoading(true)
    updatePublishApi(emailId,published ===true ? "unpublish":"publish").then((res)=>{
      // console.log("res",res);
      if(res?.data?.success){
        onClickEmail(tickedId)
      
      }
      setLoading(false);
      setAnchorEl(null);
    });
    setAnchorEl(null);
  }


// for Deleting single email qa pair
  const handleDelete = () => {
    setLoading(true)
    deleteQaPair(emailId).then((res)=>{
      onClickEmail(tickedId)
      setLoading(false)
    })
    setAnchorEl(null);
  };
  // Update Question and Answer of QA Pair.
  const handleUpdatePair=()=>{
    getIngestedEmailAnswer(answer);
    getIngestedEmailQuestion(question)
    getEmailId(emailId)
    advanceFilterModalToggle({ bool: true, value: "cmIngestedEmailQaPair" });
    setAnchorEl(null);
  }


  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
         id="long-menu"
         MenuListProps={{
           "aria-labelledby": "long-button",
         }}
         anchorEl={anchorEl}
         open={open}
         onClose={handleClose}
         PaperProps={{
           style: {
             borderRadius: "5px",
           },
         }}
      >
        <MenuItem  onClick={changePublishStatus}>
        <span style={{fontSize:'13px', fontWeight:'100'}}>{published ===true ? "Unpublish":"Publish"}</span></MenuItem>
        <MenuItem onClick={handleUpdatePair}>
        <span style={{fontSize:'13px', fontWeight:'100'}}>
        Update Content
        </span>
        </MenuItem>
        <MenuItem onClick={handleDelete}> <span style={{fontSize:'13px', fontWeight:'100'}}>Delete</span></MenuItem>
      </Menu>
    </>
  );
};

export default ThreeDotMenu;

  